module.exports = __webpack_public_path__ + "static/media/content-writing.c5b48b30.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeDo/content-writing.svg
// module id = 326
// module chunks = 0